export interface ISimpleTableAction {
  icon: string;
  title?: string;
  meta?: ActionMeta | any;
  iconClasses?: string;
  disabled?: boolean;
}

export type ActionMeta = string;

export interface ISimpleTableDropDown extends ISimpleTableAction {
  actions: ISimpleTableAction[];
}

export interface ISimpleTableColumn {
  title: string;
  width?: string;
  align?: string;
  sortFunction?: (a: any, b: any) => number;
}

export interface ISimpleTableRow {
  cells: {
    icon?: string;
    iconUrl?: string;
    iconColor?: string;
    autoIcon?: string;
    text?: string;
    tooltip?: string;
    actions?: (ISimpleTableAction | ISimpleTableDropDown)[];
    checkbox?: { checked: boolean };
    fileExtension?: string;
  }[];
  data?: any;
  selected?: boolean;
  disabled?: boolean;
  rowTooltipText?: string;
}

export interface ISimpleTableData {
  columnHeadings?: ISimpleTableColumn[];
  rows: ISimpleTableRow[];
}

/**
 * Sort functions to be used with thw ISimpleTableColumn sortFunction property.
 * These functions do not work with ISimpleTableRow items.
 */
export class SimpleTableSortFunctions {
  static sortByTextField(fieldName: string): (a: any, b: any) => number {
    return (a: any, b: any) => a[fieldName].localeCompare(b[fieldName]);
  }

  static sortByNumberField(fieldName: string): (a: any, b: any) => number {
    return (a: any, b: any) => a[fieldName] - b[fieldName];
  }
}
